module.exports = __webpack_public_path__ + "static/media/Lisboa.41620f71.svg";